import { VariableName } from '../../types/enums';
import {
  LauncherElement,
  LauncherElementTypeName,
} from '../../types/launcherElement';
import { getElementById } from './getElementById';

export const addElement = ({
  elements,
  elementType,
  targetId,
  index,
  elementData,
}: {
  elements: LauncherElement[];
  elementType?: LauncherElementTypeName;
  targetId?: string | null;
  index?: number | null;
  elementData?: LauncherElement | null;
}) => {
  const element = elementData || createElementData(elementType || 'div');
  if (!element) {
    console.log('Cannot create element');
    return [elements, null] as const;
  }

  let [target, targetParent] = getElementById(elements, targetId || '');

  if (!target?.props?.children) {
    target = targetParent;
  }

  if (target && target.props.children) {
    if (index !== undefined && index !== null) {
      target.props.children.splice(index, 0, element);
    } else {
      target.props.children = [...target.props.children, element];
    }
  } else {
    if (index !== undefined && index !== null) {
      elements.splice(index, 0, element);
    } else {
      elements = [...elements, element];
    }
  }

  return [elements, element] as const;
};

// ------------------------------

function createElementData(
  elementType: LauncherElementTypeName
): LauncherElement | null {
  let element: LauncherElement | null = null;
  switch (elementType) {
    case 'div':
      element = {
        type: 'div',
        id: crypto.randomUUID(),
        name: 'Box',
        props: {
          class: {
            position: 'relative',
            width: 200,
            height: 200,
            backgroundColor: '#cccccc',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          },
          children: [],
        },
      };
      break;
    case 'button':
      element = {
        type: 'button',
        id: crypto.randomUUID(),
        name: '',
        props: {
          command: {
            type: 'start-app-command',
          },
          class: {
            position: 'relative',
            width: 200,
            height: 100,
            backgroundColor: '#aaaaaa',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          },
          children: [],
        },
      };
      break;
    case 'text':
      element = {
        type: 'text',
        id: crypto.randomUUID(),
        name: '',
        props: {
          text: 'Text',
          class: { position: 'relative' },
        },
      };
      break;
    case 'variableText':
      element = {
        type: 'variableText',
        id: crypto.randomUUID(),
        name: '',
        props: {
          variable: VariableName.AppName,
          class: { position: 'relative' },
        },
      };
      break;
    case 'link':
      element = {
        type: 'link',
        id: crypto.randomUUID(),
        name: 'Link',
        props: {
          href: 'https://example.com',
          text: 'Link',
          class: { position: 'relative' },
        },
      };
      break;
    case 'img':
      element = {
        type: 'img',
        id: crypto.randomUUID(),
        name: 'Img',
        props: {
          src: 'https://picsum.photos/200',
          class: { position: 'relative' },
        },
      };
      break;
    case 'iframe':
      element = {
        type: 'iframe',
        id: crypto.randomUUID(),
        name: 'IFrame',
        props: {
          src: 'https://patchkit.net/',
          class: { position: 'relative', width: 500, height: 500 },
        },
      };
      break;
    case 'appTaskProgressBar':
      element = {
        type: 'div',
        id: crypto.randomUUID(),
        name: 'Progressbar',
        props: {
          class: {
            boxSizing: 'border-box',
            position: 'relative',
            width: 500,
            height: 50,
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          children: [
            {
              type: 'div',
              id: crypto.randomUUID(),
              name: 'Fill Container',
              props: {
                class: {
                  width: '100%',
                  height: 30,
                  backgroundColor: 'lightgray',
                  borderRadius: '10px',
                },
                children: [
                  {
                    type: 'appTaskProgressBar',
                    id: crypto.randomUUID(),
                    name: 'Progressbar Fill',
                    props: {
                      class: {
                        position: 'relative',
                        flex: 1,
                        height: '100%',
                        backgroundColor: 'lightblue',
                        borderRadius: '10px',
                      },
                    },
                  },
                ],
              },
            },
          ],
        },
      };
      break;
  }
  return element;
}
